import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthContext } from './hooks/useAuthContext'
import { useAdminAuth } from './hooks/useAdminAuth'
//pages
import Home from "./pages/Home"
import Admin from "./pages/Admin/Admin"
import Login from './pages/Admin/Login'
import UserLogin from './pages/User/UserLogin'
import Main from './pages/User/Main'
import { JSX } from 'react'
import Callback from './pages/User/Callback'
import CreatePerson from './pages/User/CreatePerson'
import UserTypeSelection from './pages/User/UserTypeSelection'
import EditPerson from './pages/User/EditPerson'
import CreatePrihlaska from './pages/User/CreatePrihlaska'
import { Spinner } from './components/ui'

// Protected Route Component for Admin
const ProtectedAdminRoute = ({ children }: { children: JSX.Element }) => {
  const { hasAdminAccess, isAuthenticated, initialized } = useAdminAuth()

  // Wait for auth initialization (reading from localStorage / validation)
  if (!initialized) {
    // Render spinner while auth is being initialized
    return <Spinner />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (isAuthenticated && !hasAdminAccess) {
    return <Navigate to="/" replace />
  }

  return children
}

function App(): JSX.Element {
  const { user } = useAuthContext()
  const { hasAdminAccess } = useAdminAuth()

  return (
    <BrowserRouter>
      <main className='min-h-screen flex flex-col w-full overflow-x-hidden bg-gray-50 relative'>
        <div className='flex-1 w-full max-w-full'>
          <Routes>
            <Route path="admin/*" element={
              <ProtectedAdminRoute>
                <Admin />
              </ProtectedAdminRoute>
            } />
            <Route path="login" element={
              !user ? <Login /> :
                hasAdminAccess ? <Navigate to="/admin" /> :
                  <Navigate to="/" />
            } />
            <Route path="/user-login" element={<UserLogin />} />
            <Route path="/callback" element={<Callback />} />
            <Route path="/user-type-selection" element={<UserTypeSelection />} />
            <Route path="/create" element={<CreatePerson />} />
            <Route path="/edit-person/:id" element={<EditPerson />} />
            <Route path="/create-prihlaska/:personId" element={<CreatePrihlaska />} />
            <Route index element={<Home />} />
            <Route path="/main" element={<Main />} />
          </Routes>
        </div>
      </main>
    </BrowserRouter>
  )
}

export default App
